<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-4"></div>

      <div class="col-lg-4">
        <div class="card">
          <p class="title">E-mailadres bevestigen</p>

          <p>We hebben een bevestigings-mail verstuurd naar het ingegeven e-mailadres. Gelieve op de link in deze mail
            te klikken om jouw registratie te voltooien.</p>

          <v-button class="save-changes-button" buttonText="Terug naar inloggen" v-on:clicked="backToLogin"
                    :enabled="true"></v-button>

        </div>
      </div>
    </div>

    <div class="col-lg-4"></div>

  </div>
</template>

<script>
import VButton from "@/components/UI/VButton";

export default {
  name: "RegisterConfirmed",
  components: { VButton },
  inject: [ "doApiRequest" ],
  data()
  {
    return {
      passwordObj: {
        currentPassword: '',
        newPassword: '',
        newPasswordRepeated: ''
      }
    }
  },
  methods: {
    backToLogin()
    {
      this.$router.push({ name: "login" });
    },
  }
}
</script>

<style lang="scss" scoped>
.agenda-cards {
  align-items: flex-start;
}

.card {
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  padding: 25px;
  margin-top: 25px;
  //min-width: 402px;

  .title {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .subtitle {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }
}

.save-changes-button {
  margin-bottom: 25px;
}

.cancel-button {
  align-self: center;
}

.change-password-form {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
}
</style>